import React, { useState } from 'react';
import ProjectCard from '../components/ProjectCard';

const Projects = ({ projects }) => {
  const [filter, setFilter] = useState('all');
  
  // Extract unique technologies from all projects for filtering
  const allTechnologies = [...new Set(projects.flatMap(project => project.technologies))];
  
  // Filter projects based on selected technology
  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(project => project.technologies.includes(filter));
  
  return (
    <div className="pt-24 pb-16">
      <div className="section">
        <div className="max-w-7xl mx-auto">
          <h1 className="section-title text-center">Fun Side Projects</h1>
          <p className="text-gray-400 text-center max-w-3xl mx-auto mt-4">
            A collection of experiments, prototypes, and practical builds that sit outside formal work.
          </p>
          
          {/* Filter */}
          <div className="mb-12">
            <div className="flex flex-wrap items-center justify-center gap-3">
              <button
                className={`px-4 py-2 rounded-full text-sm transition-colors ${
                  filter === 'all' 
                    ? 'bg-primary-600 text-white' 
                    : 'bg-dark-700 text-gray-300 hover:bg-dark-600'
                }`}
                onClick={() => setFilter('all')}
              >
                  All Side Projects
              </button>
              
              {allTechnologies.map(tech => (
                <button
                  key={tech}
                  className={`px-4 py-2 rounded-full text-sm transition-colors ${
                    filter === tech 
                      ? 'bg-primary-600 text-white' 
                      : 'bg-dark-700 text-gray-300 hover:bg-dark-600'
                  }`}
                  onClick={() => setFilter(tech)}
                >
                  {tech}
                </button>
              ))}
            </div>
          </div>
          
          {/* Projects Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.length > 0 ? (
              filteredProjects.map(project => (
                <ProjectCard key={project.id} project={project} />
              ))
            ) : (
              <div className="col-span-full text-center py-16">
                <h3 className="text-xl text-gray-400 mb-4">No projects found with the selected filter.</h3>
                <button
                  className="btn-primary"
                  onClick={() => setFilter('all')}
                >
                  View All Side Projects
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
